import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import PageTitle from 'components/UI/PageTitle';
import type React from 'react';
import { useState } from 'react';

import ClientsDashboard from './components/ClientsDashboard';
import FinancialPerformanceDashboard from './components/FinancialPerformanceDashboard';
import LeadsDashboard from './components/LeadsDashboard';
import RevenueDashboard from './components/RevenueDashboard';

interface TabPanelProps {
  children: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`relif-dashboard-tabpanel-${index}`}
      aria-labelledby={`relif-dashboard-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            mt: 3,
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `relif-dashboard-tab-${index}`,
    'aria-controls': `relif-dashboard-tabpanel-${index}`,
  };
};

const MIN_DASHBOARD_YEAR = 2024;

const RelifDashboard: React.FC = () => {
  const currentDate = new Date();
  const defaultYear = currentDate.getFullYear();
  const yearOptions = Array.from(
    { length: currentDate.getFullYear() - MIN_DASHBOARD_YEAR + 1 },
    (_, i) => MIN_DASHBOARD_YEAR + i
  ).reverse();

  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedYear, setSelectedYear] = useState<number>(defaultYear);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Box sx={{ px: 2, pt: 2, bgcolor: 'background.default', minHeight: '100vh' }}>
      <PageTitle subtitle="Métricas de negocio y rendimiento de Relif" sx={{ mb: 4 }}>
        Relif Dashboard
      </PageTitle>

      <Box sx={{ mb: 3 }}>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="relif-dashboard-year-label">Año</InputLabel>
          <Select
            labelId="relif-dashboard-year-label"
            value={selectedYear}
            label="Año"
            onChange={(e) => setSelectedYear(e.target.value as number)}
          >
            {yearOptions.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={selectedTab} onChange={handleTabChange} aria-label="relif dashboard tabs">
          <Tab label="Leads" {...a11yProps(0)} />
          <Tab label="Revenue" {...a11yProps(1)} />
          <Tab label="Clients" {...a11yProps(2)} />
          <Tab label="Financial Performance" {...a11yProps(3)} />
        </Tabs>
      </Box>

      <TabPanel value={selectedTab} index={0}>
        <LeadsDashboard selectedYear={selectedYear} />
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <RevenueDashboard selectedYear={selectedYear} />
      </TabPanel>
      <TabPanel value={selectedTab} index={2}>
        <ClientsDashboard selectedYear={selectedYear} />
      </TabPanel>
      <TabPanel value={selectedTab} index={3}>
        <FinancialPerformanceDashboard selectedYear={selectedYear} />
      </TabPanel>
    </Box>
  );
};

export default RelifDashboard;
